import { createFileRoute } from "@tanstack/react-router"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import {
  createWebsiteSchema,
  generateStructuredData,
} from "@repo/seo/generate-structured-data"
import { NotImplemented } from "@repo/ui/components/ui/not-implemented"
import { sharedConfig } from "~/lib/config/shared"

export const Route = createFileRoute("/_public-layout/")({
  component: HomeScreen,
  beforeLoad: async () => {
    return {
      title: "Home",
    }
  },
  head: ({ match }) => ({
    meta: generateMetaTags({
      base: {
        title: `${match.context.title} | ${sharedConfig.appName}`,
        description: "Central Management System for Media Matters",
        url: sharedConfig.baseUrl,
      },
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateStructuredData(
            createWebsiteSchema({
              url: sharedConfig.baseUrl,
              name: sharedConfig.appName,
              description: "Central Management System for Media Matters",
            }),
          ),
        ),
      },
    ],
  }),
})

function HomeScreen() {
  return (
    <main className="flex min-h-0 grow flex-col justify-center">
      <div className="mx-auto px-4 md:px-6">
        <NotImplemented
          title="Coming Soon"
          description="This site is under development."
        />
      </div>
    </main>
  )
}
